import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { default as NavigationMenu } from '@material-ui/icons/Menu';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';

import { AppBar } from '../../../components/material-ui/AppBar';
import { Tabs, Tab } from '../../../components/material-ui/Tabs';
import Target from '../../../icons/image/Target';
import Clock from '../../../icons/image/Clock';
import Route from '../../../icons/image/Route';

export const SettingTabs = memo(({ onChange, tabIndex }) => {
    const { t: translate } = useTranslation();

    return (
        <AppBar position="static" color="default">
            <Tabs
                value={tabIndex}
                onChange={onChange}
                variant="scrollable"
                scrollButtons="off"
                indicatorColor="primary"
                textColor="primary"
                aria-label="scrollable force tabs example"
            >
                <Tab
                    label={`${translate('date')}/${translate('time')}`}
                    icon={<Clock width={24} height={24} style={{ marginBottom: '4px' }} />}
                />
                <Tab label="GPS" icon={<Target width={24} height={24} style={{ marginBottom: '4px' }} />} />
                <Tab label={translate('labels.enroute')} icon={<Route width={24} height={24} style={{ marginBottom: '4px' }} />} />
                <Tab
                    label={translate('labels.notifications')}
                    icon={<NotificationImportantIcon width={24} height={24} style={{ marginBottom: '4px' }} />}
                />
                <Tab
                    label={translate('labels.partitions')}
                    icon={<NavigationMenu width={24} height={24} style={{ marginBottom: '4px' }} />}
                />
            </Tabs>
        </AppBar>
    );
});
